"use client"; // Ensures the component runs on the client side

import { useState } from "react";
import { Link } from 'react-router-dom';
import teamImg1 from '../../assets/images/team/Kims.jpg';
import teamImg2 from '../../assets/images/team/NewChadM.jpg';
import teamImg3 from '../../assets/images/team/Yacht.jpg';

export default function TeamOne() {
  // State for dynamic content
  const [teamContent] = useState({
    tagline: "What Our Clients Say",
    title: "Trusted by Businesses Nationwide",
    members: [
      {
        id: 3,
        name: "E.A. Remondi",
        role: "Yacht Club Member",
        image: teamImg3,
        hoverText:
          "Love U Brand it! Customer Service was top notch, and they were so helpful with my million questions. Pricing was very competitive, and all of our yacht club members were very happy with their shirts and hats. Highly recommend!",
        link: "/contact",
      },
      {
        id: 2,
        name: "Chad M",
        role: "Team First State Properties",
        image: teamImg2,
        hoverText:
          "I wanted to take a moment to appreciate the exceptional service and high-quality products that Vince & his company U Brand It consistently delivers year-after-year! From your mind-blowing creativity to your attention to detail sharper than a ninja's sword, your team knows how to dazzle and delight. Your creativity and unique apparel have greatly contributed to our company's success and growth!",
        link: "/contact",
      },
      {
        id: 1,
        name: "Kim",
        role: "Kim's Kitchen",
        image: teamImg1,
        hoverText:
          "I received this beautiful wood cutting board as a housewarming gift and I absolutely love it! Not only is it made from excellent quality wood, but I use it as both a cutting board and a charcuterie board too. And when it's not being used it looks lovely just on display in my sunflower themed kitchen!!!",
        link: "/contact",
      },
    ],
  });

  return (
    <>
      {/* Team One Start */}
      <section id="th-team" className="team-one">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">{teamContent.tagline}</span>
            </div>
            <h2 className="section-title__title">
              {teamContent.title.split(" & ").map((text, index) => (
                <span key={index}>
                  {text}
                  <br />
                </span>
              ))}
            </h2>
          </div>
          <div className="row">
            {teamContent.members.map((member, index) => (
              <div
                key={member.id}
                className={`col-xl-4 col-lg-6 wow fadeIn${
                  index === 0 ? "Left" : index === 1 ? "Up" : "Right"
                }`}
                data-wow-delay={`${(index + 1) * 100}ms`}
              >
                <div className="team-one__single">
                  <div className="team-one__img-box">
                    <div className="team-one__img">
                      <img src={member.image} alt={member.name} />
                      <div className="team-one__content">
                        <h4 className="team-one__name">
                          <Link to={member.link}>{member.name}</Link>
                        </h4>
                        <p className="team-one__sub-title">{member.role}</p>
                      </div>
                      <div className="team-one__content-hover">
                        <h4 className="team-one__name-hover">
                          <Link to={member.link}>{member.name}</Link>
                        </h4>
                        <p className="team-one__sub-title-hover">{member.role}</p>
                        <p className="team-one__text-hover">{member.hoverText}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Team One End */}
    </>
  );
}
